import type {
    GetDomainRequest,
    GetDomainResponse,
    GetTemplatesWithAssociationsRequest,
    GetTemplatesWithAssociationsResponse,
} from "@amzn/d16-g-cdb-publisher-portal-typescript-client";
import {
    D16GCDBPublisherPortalClient,
    GetDomainCommand,
    GetTemplatesWithAssociationsCommand,
    Stages,
} from "@amzn/d16-g-cdb-publisher-portal-typescript-client";
import { getCredentialsFromCacheOrCognito } from "@amzn/midway-cognito-type-script-provider";

import { authStore } from "../../store/auth";
import { FeatureFlagsStore } from "../../store/featureFlags";
import { APPENV } from "../../utils/app.environment";

export class PublisherPortalApiClient {
    public client: D16GCDBPublisherPortalClient;
    public stage: string;
    constructor(client: D16GCDBPublisherPortalClient, stage: string) {
        this.client = client;
        this.stage = stage;
    }

    getDomain: (request: GetDomainRequest) => Promise<GetDomainResponse> =
        async (request) => {
            if (!request.stage) {
                request.stage = this.stage as Stages;
            }
            if (FeatureFlagsStore.getState().uatPackagedInsights) {
                request.stage = Stages.UAT;
            }
            return this.client.send(new GetDomainCommand({ ...request }));
        };

    getTemplatesWithAssociations: (
        request: GetTemplatesWithAssociationsRequest,
    ) => Promise<GetTemplatesWithAssociationsResponse> = async (request) => {
        const stage = FeatureFlagsStore.getState().uatPackagedInsights
            ? Stages.UAT
            : (this.stage as Stages);
        return this.client.send(
            new GetTemplatesWithAssociationsCommand({
                stage,
                ...request,
            }),
        );
    };
}

export async function getPublisherPortalApiClient(): Promise<PublisherPortalApiClient> {
    try {
        const {
            settings: { cognitoPoolId, region, ppApiEndpoint, stage },
        } = authStore.getState();

        if (!ppApiEndpoint) {
            throw new Error("Publisher portal endpoint not yet defined");
        }

        const credentials = await getCredentialsFromCacheOrCognito({
            region,
            identityPoolId: cognitoPoolId,
            clientId: window.location.host,
            redirectUri: window.location.href,
        });
        const client = new D16GCDBPublisherPortalClient({
            endpoint: `${APPENV.mock_server ? "http" : "https"}://${ppApiEndpoint}`,
            region,
            credentials,
        });
        return new PublisherPortalApiClient(client, stage);
    } catch (e: any) {
        throw new Error(e.message);
    }
}

export const getTemplateDownloadLink: (key: string | undefined) => string = (
    key,
) => {
    if (!key) {
        return "";
    }
    const {
        settings: { ppApiEndpoint },
    } = authStore.getState();
    return `https://${ppApiEndpoint.replace("api", "templates")}/${key}`;
};
